import { render, staticRenderFns } from "./card.vue?vue&type=template&id=3777d15c"
var script = {}
import style0 from "./card.vue?vue&type=style&index=0&id=3777d15c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports